function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Update callback function
 * @callback ModelListener~updateCallback
 * @param {Model} model Model
 * @param {Component} component Component received in ModelListener constructor.
 * @param {?object} changed Model's change event parameters. Null if the callback is triggered by render or setModel.
 */

/**
 * A helper class for model components
 */
var ModelListener =
/*#__PURE__*/
function () {
  /**
   * Creates a new ModelListener instance
   * @param {Model} [model] Optional model object
   * @param {Component} component Component
   * @param {ModelListener~updateCallback} update Callback function called on model change and when component is rendered
   */
  function ModelListener(model, component, update) {
    _classCallCheck(this, ModelListener);

    this.model = model;
    this.component = component;
    this.update = update;
    this.rendered = false;
    this._onModelChange = this._onModelChange.bind(this);
  }

  _createClass(ModelListener, [{
    key: "onRender",
    value: function onRender() {
      this._setEventListener(true);

      this._onModelChange(null);

      this.rendered = true;
    }
  }, {
    key: "onUnrender",
    value: function onUnrender() {
      this._setEventListener(false);

      this.rendered = false;
    }
    /**
     * Set model
     * If component is rendered, update will be triggered.
     * @param {?Model} model Model
     * @returns {this}
     */

  }, {
    key: "setModel",
    value: function setModel(model) {
      model = model || null;

      if (model === this.model) {
        return;
      }

      if (this.rendered) {
        this._setEventListener(false);

        this.model = model;

        this._setEventListener(true);

        this._onModelChange(null);
      } else {
        this.model = model;
      }

      return this;
    }
  }, {
    key: "_setEventListener",
    value: function _setEventListener(on) {
      if (!this.model || !this.model.on || !this.update) {
        return;
      }

      if (on) {
        this.model.on('change', this._onModelChange);
      } else {
        this.model.off('change', this._onModelChange);
      }
    }
  }, {
    key: "_onModelChange",
    value: function _onModelChange(changed) {
      if (this.update) {
        this.update(this.model, this.component, changed);
      }
    }
  }]);

  return ModelListener;
}();

export default ModelListener;